(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolong-game/assets/javascripts/context/prolong-context.js') >= 0) return;  svs.modules.push('/components/numbergames/prolong-game/assets/javascripts/context/prolong-context.js');
"use strict";


const {
  useState,
  createContext
} = React;
const {
  getAllItsIds
} = svs.numbergames.productMapping;
const {
  utils: {
    checkSavedWagerInfo
  }
} = svs.numbergames.prolong_game.common;
const {
  useAccountBalance,
  usePrice
} = svs.numbergames.prolong_game.hooks;
const ProlongContext = createContext();
const ProlongProvider = _ref => {
  var _wager$properties, _svs$utils$paramHandl, _ref2, _preparedProlongWager, _wager$wager, _preparedProlongWager2;
  let {
    children,
    wager,
    trackingCategory = 'Prolong Game',
    onSuccessCb,
    onDoneCb,
    onCancelCb,
    getAfterChangeReturnUrl
  } = _ref;
  const {
    wagerId,
    totalDrawCount,
    productName,
    isSyndicate
  } = wager;
  const syndicateId = (_wager$properties = wager.properties) === null || _wager$properties === void 0 ? void 0 : _wager$properties.syndicateId;
  const [wasReturnedFromDeposit, setWasReturnedFromDeposit] = useState((_svs$utils$paramHandl = svs.utils.paramHandler.get({
    key: 'afterpay'
  })) === null || _svs$utils$paramHandl === void 0 ? void 0 : _svs$utils$paramHandl.value);
  const [preparedProlongWager, setPreparedProlongWager] = useState(checkSavedWagerInfo(wagerId));
  const initialDrawCount = (_ref2 = (_preparedProlongWager = preparedProlongWager === null || preparedProlongWager === void 0 ? void 0 : preparedProlongWager.drawCount) !== null && _preparedProlongWager !== void 0 ? _preparedProlongWager : (_wager$wager = wager.wager) === null || _wager$wager === void 0 || (_wager$wager = _wager$wager.bets[0]) === null || _wager$wager === void 0 ? void 0 : _wager$wager.originalNumDraws) !== null && _ref2 !== void 0 ? _ref2 : totalDrawCount.toString();
  const [drawCount, setDrawCount] = useState(initialDrawCount);
  const [selectedDays, setSelectedDays] = useState((_preparedProlongWager2 = preparedProlongWager === null || preparedProlongWager === void 0 ? void 0 : preparedProlongWager.selectedDays) !== null && _preparedProlongWager2 !== void 0 ? _preparedProlongWager2 : getAllItsIds(productName));
  const price = usePrice(drawCount, selectedDays, wager);
  const {
    accountBalance,
    isInitialised,
    accountIsSyndicate
  } = useAccountBalance(syndicateId, isSyndicate);
  const onCancelCallback = args => {
    setPreparedProlongWager({});
    setWasReturnedFromDeposit(false);
    onCancelCb === null || onCancelCb === void 0 || onCancelCb(args);
  };
  const onSuccessCallback = args => {
    setPreparedProlongWager({});
    setWasReturnedFromDeposit(false);
    onSuccessCb === null || onSuccessCb === void 0 || onSuccessCb(args);
  };
  return React.createElement(ProlongContext.Provider, {
    value: {
      drawCount,
      setDrawCount,
      wager,
      selectedDays,
      setSelectedDays,
      price,
      accountBalance,
      accountIsSyndicate,
      preparedProlongWager,
      isInitialised,
      trackingCategory,
      onCancelCb: onCancelCallback,
      onSuccessCb: onSuccessCallback,
      onDoneCb,
      getAfterChangeReturnUrl,
      wasReturnedFromDeposit,
      shouldResumePayment: preparedProlongWager.isExisting && isInitialised && price > 0
    }
  }, children);
};
setGlobal('svs.numbergames.prolong_game.context', {
  ProlongContext,
  ProlongProvider
});

 })(window);